export const grid = {
    colGap: { _: 5, l: 6, m: 5, xl: 6 },
    gridGap: { _: 4, l: 8, m: 6, xl: 8 },
    numCols: { _: 6, l: 12, m: 12, xl: 12 },
    rowGap: { _: 5, l: 6, m: 5, xl: 6 },
};
//# sourceMappingURL=grid.js.map